<div class="blog-listing bg-gradient-to-b from-[#fef3ef] ">

  <!-- ── Background layers (agents-page style) ── -->
  <div class="bl-bg-base"></div>
  <div class="bl-bg-glow bl-bg-glow--tr"></div>
  <div class="bl-bg-glow bl-bg-glow--bl"></div>
  <div class="bl-bg-glow bl-bg-glow--center"></div>
  <div class="bl-bg-dots"></div>
  

  <ng-container *ngIf="vm$ | async as vm; else blogSkeleton">

    <!-- ── Hero ── -->
    <section class="bl-hero">
      <div class="bl-shell">
        <div class="bl-hero-grid">

          <div class="bl-hero-copy">
            <span class="bl-eyebrow">
              <span class="bl-eyebrow-dot"></span>
              Good Reads
            </span>
            <h1 class="bl-hero-heading">
              Insights for<br>modern B2B.<br>Ideas that stick.
            </h1>
            <p class="bl-hero-sub">
              Strategy, playbooks and real-world GTM stories for revenue teams.
            </p>
          </div>

          <div class="bl-hero-featured" *ngIf="vm.latestPost as post">
            <div class="bl-hero-card" (click)="open(post)">
              <div class="bl-hero-thumb">
                <img
                  *ngIf="post.thumbnailUrl"
                  [src]="post.thumbnailUrl"
                  [alt]="post.title"
                  loading="eager"
                />
                <div class="bl-thumb-placeholder" *ngIf="!post.thumbnailUrl"></div>
              </div>
              <div class="bl-card-meta ml-4">
                <span class="bl-tag-pill" style="--tag-color:#e03b3b">
                  <span class="bl-dot" style="background:#e03b3b"></span>
                  {{ post.tagIds[0] || 'Blog' }}
                </span>
                <span class="bl-meta-date" *ngIf="post.publishedAt">{{ post.publishedAt }}</span>
              </div>
              <h3 class="bl-hero-card-title">{{ post.title }}</h3>
              <p class="bl-hero-card-excerpt" *ngIf="post.excerpt">{{ post.excerpt }}</p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- ── Filter bar ── -->
    <section class="bl-filter-bar">
      <div class="bl-shell bl-filter-inner">

        <div class="bl-filter-left">
          <span class="bl-filter-label">I'm looking for...</span>
          <div class="bl-chips">
            <button
              type="button"
              class="bl-chip"
              *ngFor="let t of vm.allTags; let i = index"
              (click)="scrollToTag(t)"
            >
              <span class="bl-dot" [style.background]="getTagColour(i)"></span>
              {{ t }}
            </button>
          </div>
        </div>

        <div class="bl-filter-search">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="6.5" cy="6.5" r="4.5" stroke="#9ca3af" stroke-width="1.5"/>
            <path d="M10.5 10.5L14 14" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input
            type="text"
            [formControl]="searchControl"
            placeholder="Search"
            aria-label="Search blog posts"
          />
          <button type="button" class="bl-clear-btn" *ngIf="searchControl.value" (click)="clearSearch()" aria-label="Clear search">✕</button>
        </div>

      </div>
    </section>

    <!-- ── Search results ── -->
    <section class="bl-section" *ngIf="vm.searchResults as results">
      <div class="bl-shell">
        <div class="bl-section-header">
          <h2 class="bl-section-title">Results for "{{ vm.query }}"</h2>
          <button type="button" class="bl-clear-results-btn" (click)="clearSearch()">Clear</button>
        </div>

        <div class="bl-cards-grid" *ngIf="results.length; else noResults">
          <article
            class="bl-card"
            *ngFor="let post of results; trackBy: trackBySlug"
            (click)="open(post)"
          >
            <div class="bl-card-thumb">
              <img *ngIf="post.thumbnailUrl" [src]="post.thumbnailUrl" [alt]="post.title" loading="lazy" />
              <div class="bl-thumb-placeholder" *ngIf="!post.thumbnailUrl"></div>
            </div>
            <div class="bl-card-meta">
              <span class="bl-tag-pill" style="--tag-color:#e03b3b">
                <span class="bl-dot" style="background:#e03b3b"></span>
                {{ post.tagIds[0] || 'Blog' }}
              </span>
              <span class="bl-meta-date" *ngIf="post.publishedAt">{{ post.publishedAt }}</span>
            </div>
            <h3 class="bl-card-title">{{ post.title }}</h3>
            <p class="bl-card-excerpt" *ngIf="post.excerpt">{{ post.excerpt }}</p>
          </article>
        </div>

        <ng-template #noResults>
          <p class="bl-empty">No posts match "{{ vm.query }}".</p>
        </ng-template>
      </div>
    </section>

    <!-- ── Tag sections ── -->
    <div id="bl-sections" *ngIf="!vm.searchResults">
      <ng-container *ngFor="let tag of vm.allTags; let ti = index">
      <section
        class="bl-section"
        [id]="'bl-section-' + tag"
        *ngIf="getTagPosts(tag, vm.allPosts).length"
      >
        <div class="bl-shell">

          <div class="bl-section-header">
            <h2 class="bl-section-title">{{ tag }}</h2>
            <div class="bl-arrows">
              <button
                type="button"
                class="bl-arrow-btn"
                [disabled]="!canGoPrev(tag)"
                (click)="carouselPrev(tag)"
                aria-label="Previous"
              >←</button>
              <button
                type="button"
                class="bl-arrow-btn"
                [disabled]="!canGoNext(tag, vm.allPosts)"
                (click)="carouselNext(tag, vm.allPosts)"
                aria-label="Next"
              >→</button>
            </div>
          </div>

          <div class="bl-cards-grid">
            <article
              class="bl-card"
              *ngFor="let post of getCarouselPosts(tag, vm.allPosts); trackBy: trackBySlug"
              (click)="open(post)"
            >
              <div class="bl-card-thumb">
                <img *ngIf="post.thumbnailUrl" [src]="post.thumbnailUrl" [alt]="post.title" loading="lazy" />
                <div class="bl-thumb-placeholder" *ngIf="!post.thumbnailUrl"></div>
              </div>
              <div class="bl-card-meta">
                <span class="bl-tag-pill" [style.--tag-color]="getTagColour(ti)">
                  <span class="bl-dot" [style.background]="getTagColour(ti)"></span>
                  {{ tag }}
                </span>
                <span class="bl-meta-date" *ngIf="post.publishedAt">{{ post.publishedAt }}</span>
              </div>
              <h3 class="bl-card-title">{{ post.title }}</h3>
              <p class="bl-card-excerpt" *ngIf="post.excerpt">{{ post.excerpt }}</p>
              <div class="bl-card-author" *ngIf="post.author.name || post.author.profilePic">
                <img
                  *ngIf="post.author.profilePic"
                  [src]="post.author.profilePic"
                  [alt]="post.author.name || ''"
                  class="bl-author-pic"
                />
                <span class="bl-author-name" *ngIf="post.author.name">{{ post.author.name }}</span>
              </div>
            </article>
          </div>

        </div>
      </section>
      </ng-container>
    </div>

    <!-- ── CTA ── -->
    <div class="bl-cta-wrap">
      <app-cta-section
        headingStart="Stay ahead with smarter"
        headingGradient="B2B insights."
        description="Connect your LinkedIn Ads account in 2 minutes and start turning data into decisions. No credit card required."
      />
    </div>

  </ng-container>

  <!-- ── Skeleton ── -->
  <ng-template #blogSkeleton>
    <div class="bl-skeleton">
      <div class="bl-shell">
        <div class="bl-sk-hero">
          <div class="bl-sk-copy">
            <div class="sk-line sk-w50"></div>
            <div class="sk-line sk-w80 sk-title"></div>
            <div class="sk-line sk-w70"></div>
            <div class="sk-line sk-w40"></div>
          </div>
          <div class="sk-thumb sk-large"></div>
        </div>
        <div class="bl-sk-grid">
          <div class="sk-card" *ngFor="let n of [1,2,3]">
            <div class="sk-thumb"></div>
            <div class="sk-line sk-w90 sk-mt"></div>
            <div class="sk-line sk-w70 sk-mt"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</div>
